import React, {useContext, useState, useEffect, useRef} from 'react';
import _ from "lodash";
import "./financeReport.scss"
import {useHistory, withRouter} from "react-router-dom";
import {Formik, Form, Field, FieldArray} from "formik";
import { StoreContext } from '../../store/context'
import Paper from '@material-ui/core/Paper';
import { DatePicker } from "@material-ui/pickers";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FixedHeaderTable from '../../components/FixedHeaderTable';
import moment from 'moment';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {PAYMENT_HISTORY_TEACHER, PAYMENT_HISTORY_STUDENT} from "../../utils/constants";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import * as yup from 'yup';
const useStyles = makeStyles({
    table: {
        minWidth: 450,
    },
});


const columns = [
    {
        id: 'studentName',
        label: 'Student Name',
        minWidth: 170
    },
    {
        id: 'courses',
        label: 'Courses',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'miscs',
        label: 'Miscs',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'transactionType',
        label: 'Transaction Type',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'transactionDate',
        label: 'Transaction Date',
        minWidth: 170,
        align: 'right',
    },
    {
        id: 'totalAmount',
        label: 'Total(RM)',
        minWidth: 170,
        align: 'right',
    }
];

const FinanceReport = () => {
    const classes = useStyles();
    const history = useHistory();
    const { state, actions } = useContext(StoreContext); // get global state and dispatch function
    const { showStudentDetailDialog, getMonthlyFinanceReport } = actions.paymentActions;
    const { monhtlyFinanceReport } = state.paymentStates;
    const [selectedDate, handleDateChange] = useState(null);

    useEffect(() => {
        // getAllMisc();
        // getAllStudents();
    }, []);

    const handleSearchButton = () => {
        if (selectedDate == null) {
            return;
        }

        const month = moment(selectedDate).format('MM-YYYY');
        getMonthlyFinanceReport(month);
        // getAllStudents(studentName, programLvl);
    };

    return (
        <div className="financial-report-container">
            <h1 className="header">Finance Report</h1>
            <div className="paperContainer">
                <FormControl className="form-control">
                    <DatePicker
                        style={{marginTop: "0px"}}
                        className="date-picker"
                        views={["year", "month"]}
                        label="Date"
                        value={selectedDate}
                        onChange={handleDateChange}
                    />
                </FormControl>

                <Button className="search-btn" variant="contained" color="primary" onClick={handleSearchButton}>
                    Search
                </Button>

                <div className="table-container">
                    <TableContainer component={Paper} style={{marginTop: "10px"}}>
                        <Table className={classes.table} aria-label="spanning table">
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{ background: "#3f51b5", color: "white" }}
                                        align="left">Transaction Type</TableCell>
                                    <TableCell
                                        style={{ background: "#3f51b5", color: "white" }}
                                        align="left">Month</TableCell>
                                    <TableCell
                                        style={{ background: "#3f51b5", color: "white" }}
                                        align="right">Total</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow key={"BANK"}>
                                    <TableCell>Bank</TableCell>
                                    <TableCell>{monhtlyFinanceReport.bank != null ? moment(monhtlyFinanceReport.bank.transactionDate, "DD-MM-YYYY").format("MMM YYYY") : ""}</TableCell>
                                    <TableCell align="right">{monhtlyFinanceReport.bank != null ? monhtlyFinanceReport.bank.totalAmount : 0}</TableCell>
                                </TableRow>

                                <TableRow key={"CASH"}>
                                    <TableCell>Cash</TableCell>
                                    <TableCell>{monhtlyFinanceReport.cash != null ? moment(monhtlyFinanceReport.cash.transactionDate, "DD-MM-YYYY").format("MMM YYYY") : ""}</TableCell>
                                    <TableCell align="right">{monhtlyFinanceReport.cash != null ? monhtlyFinanceReport.cash.totalAmount : 0}</TableCell>
                                </TableRow>

                                <TableRow key={"UNKNOWN"}>
                                    <TableCell>Unknown</TableCell>
                                    <TableCell>{monhtlyFinanceReport.unknown != null ? moment(monhtlyFinanceReport.unknown.transactionDate, "DD-MM-YYYY").format("MMM YYYY") : ""}</TableCell>
                                    <TableCell align="right">{monhtlyFinanceReport.unknown != null ? monhtlyFinanceReport.unknown.totalAmount : 0}</TableCell>
                                </TableRow>

                                <TableRow>
                                    <TableCell rowSpan={3} />
                                    <TableCell colSpan={1} align="right"><b>Total</b></TableCell>
                                    <TableCell align="right"><b>{monhtlyFinanceReport.total ? monhtlyFinanceReport.total.totalAmount : 0}</b></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

            </div>

        </div>
    )
}

export default withRouter(FinanceReport)
